import { render, staticRenderFns } from "./cms-page-blocks.vue?vue&type=template&id=15444348"
import script from "./cms-page-blocks.vue?vue&type=script&lang=js"
export * from "./cms-page-blocks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports